import { fromColorPathToColor, WeenatColor } from '@weenat/theme'
import { styled } from 'styled-components'
import { FlexProps } from '../primitives/themeMappings/props'

const Container = styled(Flex)<{
  $isFocused: boolean
  $focusColor: WeenatColor
  $focusBorderColor: WeenatColor
}>`
  position: relative;

  align-items: center;
  justify-content: center;

  overflow: hidden;

  gap: ${(p) => p.theme.spacings.md}px;

  background-color: ${({ $isFocused, $focusColor }) =>
    $isFocused ? fromColorPathToColor($focusColor) : 'transparent'};

  border-radius: ${(p) => p.theme.radiuses.md}px;
  border: 2px solid;
  border-color: ${(p) =>
    p.$isFocused ? fromColorPathToColor(p.$focusBorderColor) : p.theme.colors.grayscale[100]};

  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ $isFocused, $focusBorderColor }) =>
    $isFocused ? fromColorPathToColor($focusBorderColor) : 'inherit'};
  fill: ${({ $isFocused, $focusBorderColor }) =>
    $isFocused ? fromColorPathToColor($focusBorderColor) : 'inherit'};

  &:hover {
    cursor: pointer;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    opacity: 0.1;
    background-color: 'transparent';
    inset: 0px;
  }

  &:hover::after {
    background-color: ${(p) => p.theme.colors.grayscale.black};
  }

  transition:
    background-color 0.3s ease-in-out,
    border-color 0.3s ease-in-out;

  will-change: background-color, border-color;
`

export interface TabProps {
  isFocused: boolean
  p?: FlexProps['$p']
  onPress?: FlexProps['onClick']
  flex?: FlexProps['$flex']
  focusColor?: WeenatColor
  focusBorderColor?: WeenatColor
  className?: string
}

const Tab: FC<TabProps> = ({
  children,
  isFocused,
  flex,
  p = 'lg',
  onPress,
  focusColor = 'primary.200',
  focusBorderColor = 'primary.500',
  className
}) => {
  return (
    <Container
      $isFocused={isFocused}
      onClick={onPress}
      $flex={flex}
      $p={p}
      $focusColor={focusColor}
      $focusBorderColor={focusBorderColor}
      className={className}
    >
      {children}
    </Container>
  )
}

export default Tab
